import React, { FC, PropsWithChildren } from "react";
import { AppRouter } from "../components/Navigation"

export const RouterProvider: FC<PropsWithChildren> = ({ children }) => {
    return <AppRouter>{children}</AppRouter>;
}
